export default __webpack_public_path__ + "static/media/package-b-small.f71d1308.jpg";